import axios from "axios";
import { setLoader } from "../redux/features/loading/loaderSlice";
import useRefreshToken from "../helpers/custom-hooks/useRefreshToken";

let configureStoreClientTransaction;
export const SetupTransactionInterceptors = (store) => {
  configureStoreClientTransaction = store;
};
const axiosClientTxInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL_TRANSACTION,
});

axiosClientTxInstance.interceptors.request.use(
  function (config) {
    const token = sessionStorage?.getItem("persist:root") || [];
    const jwt = JSON.parse(token || null);
    const user = JSON.parse(jwt?.user || null) || [];
    config.headers.Authorization = user?.userInfo
      ? `Bearer ${user?.userInfo?.access_token}`
      : "";
    return config;
  },
  (error) => {
    return error;
  }
);

axiosClientTxInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const { dispatch } = configureStoreClientTransaction;
    dispatch(setLoader(false));
    const originalConfig = error.config;
    if (error?.response?.status === 401 && !originalConfig?._retry) {
      originalConfig._retry = true;
      const { refreshToken } = useRefreshToken();
      await refreshToken(dispatch);
      return axiosClientTxInstance(originalConfig);
    }

    return Promise.reject(error);
  }
);

const getTransactionDetail = async (params) => {
  let payload = {
    clientId: params.clientId,
    paymentSource: params.paymentSource,
    fromDate: params.startDate,
    todate: params.endDate,
    orderStatusType: params.OrderStatusType,
    search: params.search,
  };
  const response = await axiosClientTxInstance.post(
    `Order/get-transaction-detail-report`,
    payload
  );
  return response;
};

const getTransactionSummary = async (clientUuid) => {
  const response = await axiosClientTxInstance.get(
    `Order/get-transaction-summary-report?clientId=${clientUuid}`
  );
  return response;
};

const getDonughtChartDetails = async (params) => {
  let payload = {
    clientId: params.clientId,
    fromDate: params.fromDate,
    todate: params.todate,
  };

  const response = await axiosClientTxInstance.post(
    `Order/get_dashboard_transaction_summary`,
    payload
  );
  return response;
};

const getDropPerformance = async (params) => {
  let payload = {
    clientId: params.clientId,
    fromDate: params.fromDate,
    todate: params.todate,
  };
  const response = await axiosClientTxInstance.post(
    `/Order/get_drop_performance`,
    payload
  );
  return response;
};

const getDashboardTransaction = async (params) => {
  let payload = {
    ClientId: params.clientId,
  };
  const response = await axiosClientTxInstance.post(
    `Order/get_dashboard_transaction_report`,
    payload
  );
  return response;
};

const transferMint = async (data) => {
  const response = await axiosClientTxInstance.post(
    `Stripe/mint-transfer-manually`,
    data
  );
  return response;
};

export const ClientTxService = {
  getTransactionDetail,
  getTransactionSummary,
  getDonughtChartDetails,
  getDropPerformance,
  transferMint,
  getDashboardTransaction,
};
